import React from 'react';
import { Section, SectionTitle } from './Section';
export function NotYourFault() {
  return <Section className="bg-ink-900/60" data-id="element-159" data-mp="3vubs5ztyqc0y">
      <SectionTitle eyebrow="No es tu culpa" data-id="element-160" data-mp="3vvd384azayio">
        La verdad que nadie te dice cuando compras un iPhone
      </SectionTitle>

      <div className="space-y-5 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-161" data-mp="ejc2cc15k0cm">
        <p data-id="element-162" data-mp="9lalzyv42f4u">Cuando compraste tu iPhone, nadie te entregó un manual claro.</p>
        <p data-id="element-163" data-mp="nl22c693o7m0">
          Apple es increíble diseñando productos, pero terrible explicándote
          cómo usarlos. La cajita viene casi vacía. El vendedor de la tienda te
          configuró lo básico y te dijo «con esto ya está listo». Y después te
          dejaron solo.
        </p>
        <p data-id="element-164" data-mp="se4ovufgmgsp">
          Los tutoriales de internet son miles, pero están fragmentados. Uno te
          enseña cómo tomar una foto en modo retrato. Otro te explica cómo
          activar AirDrop. Otro te habla de iCloud. Pero nadie te lo explica
          todo de forma ordenada, clara y en un solo lugar.
        </p>
        <p className="text-white" data-id="element-165" data-mp="2t1ob4t8tcfg5">
          No es que seas malo con la tecnología.
        </p>
        <p data-id="element-166" data-mp="2x2q5avnvi1b9">
          El problema es que nunca tuviste una guía completa, organizada y fácil
          de entender.
        </p>
        <p className="text-2xl font-extrabold tracking-tight text-accent-soft sm:text-3xl" data-id="element-167" data-mp="3234ewi54hjbe">
          Hasta ahora.
        </p>
      </div>
    </Section>;
}